import React from 'react';
import { Wallet } from 'lucide-react';
import SeccionPendiente from './components/SeccionPendiente';

const NominaPagosPage = () => (
  <SeccionPendiente
    icon={Wallet}
    titulo="Pagos de nómina"
    descripcion="Registro de cómo y cuándo se pagó cada liquidación: fecha, método, banco, cuenta, número de referencia y comprobante. Hoy el estado Pagada se marca sin dejar rastro del pago."
    entrega="Disponible en la Parte 7 del módulo"
  />
);

export default NominaPagosPage;